module.exports = __webpack_public_path__ + "img/logo_2.f53868d6.png";